import axios from 'axios';

const isLocalhost = typeof window !== 'undefined'
    && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const rawBaseURL = process.env.REACT_APP_API_URL
    || (isLocalhost ? 'http://localhost:5000/api' : 'https://237elecsolution.com/api');
// Strip trailing slashes and collapse any accidental double slashes (e.g. a misconfigured env var)
const baseURL = rawBaseURL.replace(/\/+$/, '').replace(/([^:])\/{2,}/g, '$1/');

export const STOCK_TOKEN_KEY = 'stock_token';

const STOCK_API = axios.create({ baseURL });

STOCK_API.interceptors.request.use((config) => {
    const token = localStorage.getItem(STOCK_TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

const stockLogin = (data) => STOCK_API.post('/auth/login', data);

const stockApi = {
    getProducts: () => STOCK_API.get('/products'),
    createProduct: (data) => STOCK_API.post('/admin/products', data),
    updateProduct: (id, data) => STOCK_API.put(`/admin/products/${id}`, data),
    deleteProduct: (id) => STOCK_API.delete(`/admin/products/${id}`),
    getInventoryOverview: () => STOCK_API.get('/admin/inventory/overview'),
    getDailyInventory: (date) => STOCK_API.get('/admin/inventory/daily', { params: date ? { date } : {} }),
    getMonthlyInventory: (year, month) => STOCK_API.get('/admin/inventory/monthly', { params: { year, month } }),
    adjustStock: (data) => STOCK_API.post('/admin/inventory/adjust', data),
    getCompleteInventory: () => STOCK_API.get('/admin/inventory/complete'),
};

export { stockLogin, stockApi };
export default stockApi;
